<div class="logo"></div>
<ul nz-menu nzTheme='dark' nzInline nzMode="horizontal">
  <li routerLink="/" nz-menu-item>
    <i nz-icon nzType="bank" nzTheme="outline"></i>
    Home
  </li>
  <li nz-submenu nzTitle="Knowledge Graph" nzIcon="dot-chart">
    <ul>
          <!--
          <li nz-menu-item>海洋天然产物知识图谱</li>
          <li nz-menu-item>药物靶点知识图谱</li>
          <li nz-menu-item>药物文献知识图谱</li>
          <li nz-menu-item routerLink="/ppi">PPI 知识图谱</li>
          <li nz-menu-item>DDI 知识图谱</li>
          <li nz-menu-item>中医药知识图谱</li>
          <li nz-menu-item>COVID-19 知识图谱</li>
          -->
          <li nz-menu-item routerLink="/ppi">PPI Knowledge Graph</li>
    </ul>
  </li>
  
  <li nz-submenu nzTitle="Integrated Search" nzIcon="search">
    <ul>
          <li nz-menu-item routerLink="/protein_search">Protein Search</li>
          <!--
          <li nz-menu-item>结构域查询</li>
          <li nz-menu-item>物种查询</li>
          <li nz-menu-item>文献查询</li>
          <li nz-menu-item>蛋白质共现文献查询</li>
          -->
    </ul>
  </li>
  <!--
  <li nz-submenu nzTitle="数据库" nzIcon="database" *ngIf="0">
    <ul>
          <li nz-menu-item>蛋白质/基因同义词表</li>
          <li nz-menu-item>生物物种分类树</li>
          <li nz-menu-item>蛋白质共现文献</li>
          <li nz-menu-item>Taxonomy-Mesh Map</li>
          <li nz-submenu nzTitle="药学文献">
            <ul>
              <li nz-menu-item>COVID-19文献</li>
              <li nz-menu-item>冠状病毒文献</li>
            </ul>
          </li>
    </ul>
  </li>
  <li nz-submenu nzTitle="工具" nzIcon="tool" *ngIf="0">
    <ul>
          <li nz-menu-item>本体解析</li>
          <li nz-menu-item>实体切片</li>
          <li nz-menu-item>药学数据综合解析</li>
    </ul>
  </li>
  -->
</ul>